module.exports = __webpack_public_path__ + "static/media/notification_black.f7dd2975.svg";